import { useState, useContext } from "react";
import { MediaQueriesContext } from "@/App";

const useToggleDetailsInfo = () => {
  const [isToggled, setIsToggled] = useState(false);
  const { isMediaMobile } = useContext(MediaQueriesContext);

  return {
    isInfoVisible: isToggled || !isMediaMobile,
    toggleInfo: () => setIsToggled((prev) => !prev),
    isInfoToggled: isToggled,
  };
};

export default useToggleDetailsInfo;
